import { useEffect, useRef } from "react";
import type { AgentStatus } from "../server/types";

type Props = {
  thoughts: string;
  isThinking: boolean;
  status: AgentStatus;
  isRunning: boolean;
};

export function ThoughtStream({ thoughts, isThinking, status, isRunning }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [thoughts]);

  function renderStatus() {
    if (!isRunning) {
      return <span className="text-nes-gray">Press START to begin...</span>;
    }
    if (status === "executing") {
      return (
        <div className="text-nes-green font-pixel text-xs mt-2 animate-pulse">
          ⏳ Waiting for emulator...
        </div>
      );
    }
    if (isThinking && !thoughts) {
      return (
        <span className="text-nes-gold">
          🧠 Claude is analyzing the screenshot...
          <span className="nes-cursor">▌</span>
        </span>
      );
    }
    return null;
  }

  return (
    <div className="nes-panel flex flex-col" style={{ minHeight: "280px", maxHeight: "400px" }}>
      <div className="nes-panel-header">CLAUDE'S BRAIN</div>
      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto p-3 font-mono text-xs leading-relaxed text-nes-white"
        style={{ maxHeight: "350px" }}
      >
        {thoughts ? (
          <>
            <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {thoughts}
              {isThinking && <span className="nes-cursor">▌</span>}
            </span>
            {status === "executing" && (
              <div className="text-nes-green font-pixel text-xs mt-2 animate-pulse">
                ⏳ Waiting for emulator...
              </div>
            )}
          </>
        ) : (
          renderStatus()
        )}
      </div>
    </div>
  );
}
